module.exports = __webpack_public_path__ + "d3ae2a83fd09654170c26dcec5861241.jpg";